// @flow
import React, { Fragment, PureComponent } from 'react';
import { Link, Redirect } from 'react-router-dom';

import SelectInput from 'components/fragments/input/SelectInput';
import TextInput from 'components/fragments/input/TextInput';
import TextInputMaterial from 'components/fragments/input/material/TextInputMaterial';
import Loading from 'components/fragments/Loading';

import { validateEmail } from 'utils/validatorUtils';
import { getFileNameFromPath } from 'utils/urlUtils';
import { dynamicClassName } from 'utils/dynamicClassName';

import type { ThemeType } from 'types/Faq';
import type { ContactFormType, formInputsType } from 'types/ContactForm';
import type { Status } from 'types/Status';

import { STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';

export type StateProps = {
  themes?: ThemeType[],
  contactForm: ContactFormType,
  sendStatus: Status,
  fetchStatus: Status,
  contactFormList: ContactFormType[]
};

export type DispatchProps = {
  fetchThemes: () => void,
  postContactForm: (formInputs: formInputsType, id: number) => void,
  fetchContactForm: () => void,
  fetchAllContactForm: () => void
};

type Props = {
  location: any
} & StateProps &
  DispatchProps;

type State = {
  object: string | null,
  profil: string | null,
  name: string | null,
  email: string | null,
  file: string | null,
  file2: string | null,
  isPopulate: boolean,
  isOffer: boolean,
  message: string,
  error: string,
  id_form: number
};

class ContactForm extends PureComponent<Props, State> {
  props: Props;
  state: State = {
    object: null,
    profil: null,
    name: null,
    email: null,
    file: null,
    file2: null,
    isPopulate: false,
    isOffer: false,
    message: '',
    error: '',
    id_form: 0
  };

  componentDidMount = () => {
    const {
      themes,
      fetchContactForm,
      fetchThemes,
      fetchAllContactForm,
      contactFormList,
      location: { state: locationState }
    } = this.props;
    fetchContactForm();

    if (themes === []) {
      fetchThemes();
    }

    if (contactFormList.length === 0) {
      fetchAllContactForm();
    }

    if (locationState) {
      const { isPopulate, object, isOffer: isLocationOffer } = locationState;
      if (object) {
        this.setState({ isPopulate, isOffer: !!isLocationOffer });
        this.setObject(object);
      }
    }
  };

  getFormId = () => {
    const { object, isPopulate, id_form } = this.state;
    const { contactFormList } = this.props;

    /**
     * Si on est dans un cas peuplé (forcé) et qu'on n'a pas l'id_form et que l'on a plusieurs forms
     * On prend l'id du form dont le titre === l'objet
     */
    if (isPopulate && !id_form && contactFormList.length > 0) {
      const idForm = contactFormList.filter(form => form.title === object);

      if (idForm.length > 0) {
        return parseInt(idForm[0].id, 10);
      }
    }
    return id_form;
  };

  setObject = (object: string) => {
    const { themes, contactFormList } = this.props;
    this.setState({ object });
    if (themes && object !== 'Candidature Spontanée') {
      const id_form = themes.filter(theme => theme.name === object);
      if (id_form && id_form.length > 0) {
        const idform = parseInt(id_form[0].contact_lie, 10);
        this.setState({ id_form: idform > 0 ? idform : this.props.contactForm.id });
      }
    } else {
      if (contactFormList && contactFormList.length > 0) {
        const id_form = contactFormList.filter(form => form.title === object);
        if (id_form && id_form.length > 0) {
          const idform = parseInt(id_form[0].id, 10);
          this.setState({ id_form: idform > 0 ? idform : this.props.contactForm.id });
        }
      }
    }
  };

  setProfil = (profil: string) => {
    this.setState({ profil });
  };

  setName = (name: string) => {
    this.setState({ name });
  };

  setEmail = (email: string) => {
    this.setState({ email });
  };

  setFile = (e: any) => {
    const file = e.target.value;
    this.setState({ file });
  };

  setFile2 = (e: any) => {
    const file2 = e.target.value;
    this.setState({ file2 });
  };

  setMessage = (e: any) => {
    const message = e.target.value;
    this.setState({ message });
  };

  isFileValid = () => {
    // eslint-disable-next-line
    const input: any = document.querySelector('input[type="file"]#file');
    const input2: any = document.querySelector('input[type="file"]#file2');
    if (input2) {
      const documentData2 = input2.files[0];
      if (documentData2 && documentData2.type !== 'application/pdf') {
        return false;
      }
    }
    if (input) {
      const documentData = input.files[0];
      return !documentData || documentData.type === 'application/pdf';
    } else return false;
  };

  isFormValid = () => {
    const { object, isPopulate, profil, name, email } = this.state;

    if (object === null && !isPopulate) return false;
    if (profil === null) return false;
    if (name === null || name === '') return false;
    if (email === null || !validateEmail(email)) return false;

    return true;
  };

  handleSubmit = (e: MouseEvent) => {
    e.preventDefault();
    const { name, email, profil, object, message, isPopulate, isOffer } = this.state;

    this.setState({ error: '' });

    if (this.isFormValid()) {
      if (this.isFileValid()) {
        const { postContactForm } = this.props;

        const input: any = document.querySelector('input[type="file"]#file');
        const documentData: HTMLInputElement = input.files[0];

        const {
          location: { state: locationState }
        } = this.props;
        let messageLink = ``;

        if (isOffer && locationState && locationState.link) {
          const host = window.location.origin;
          messageLink = `\n Lien vers l'offre : ${host}${locationState.link}`;
        }

        const messageToSend = isOffer ? `${message} ${messageLink}` : message;

        // eslint-disable-next-line
        let formData = {
          'ffr-name': name ? name : '',
          'ffr-email': email ? email : '',
          'ffr-profil': profil ? profil : '',
          'ffr-subject': object ? object : '',
          'ffr-message': message ? messageToSend : '',
          'ffr-contact-file': documentData
        };

        let { id_form } = this.state;

        if (isPopulate && object === 'Candidature Spontanée') {
          const input2: any = document.querySelector('input[type="file"]#file2');
          var documentData2: HTMLInputElement = input2.files[0];
          //$FlowFixMe
          formData['ffr-contact-file-2'] = documentData2;
        }

        if (id_form === 0) {
          id_form = this.getFormId();
        }

        formData = { ...formData, _wpcf7_unit_tag: id_form };

        postContactForm(formData, id_form);
      } else {
        this.setState({
          error: 'Vous ne pouvez envoyer que des fichiers .pdf'
        });
      }
    } else {
      this.setState({
        error: 'Veuillez vérifier le contenu du formulaire',
        object: object === null ? '' : object,
        profil: profil === null ? '' : profil,
        name: name === null ? '' : name,
        email: email === null ? '' : email
      });
    }
  };

  _renderObjectInput = () => {
    const { themes } = this.props;
    const { object, isPopulate } = this.state;

    if (isPopulate) {
      return <TextInputMaterial id="object" isLight label="Objet de ma demande" disable defaultValue={object} />;
    }

    /**
     * Enlever proposition-emploi du sélecteur de sujet du formulaire de base
     */
    const objects = themes
      ? themes
          .filter(theme => theme.slug !== 'proposition-emploi')
          .map(theme => ({ label: theme.name, value: theme.name }))
      : [];

    return (
      <SelectInput
        isLight
        placeholder="Objet de ma demande"
        options={objects}
        onChange={this.setObject}
        hasError={object === ''}
        defaultValue={object}
        errorMessage={'Ce champ est requis'}
      />
    );
  };

  render() {
    const { fetchStatus, sendStatus } = this.props;
    const { error, isPopulate, object } = this.state;

    if (fetchStatus === STATUS_LOADING) {
      return <Loading isWhite />;
    }

    const classNamesSend = dynamicClassName('btn btn--primary js-contact-send');
    sendStatus === STATUS_LOADING && classNamesSend.add('is-disabled');

    if (sendStatus === STATUS_SUCCESS) {
      return <Redirect to="/faq" />;
    }

    return (
      <div className="form-contact block-contact__form" style={{ display: 'block' }}>
        <h3 className="mb-1">Votre demande</h3>
        <p className="mb-3">Remplissez les champs ci-dessous pour contacter la fédération.</p>
        <form action="#">
          {this._renderObjectInput()}
          <div className="form-contact__row">
            <div className="form-contact__select">
              <SelectInput
                isLight
                placeholder="Je suis..."
                options={[
                  { label: 'Licencié', value: 'Licencié' },
                  { label: 'Dirigeant de club', value: 'Dirigeant de club' },
                  { label: 'Entraineur', value: 'Entraineur' },
                  { label: 'Parent de joueur', value: 'Parent de joueur' },
                  { label: 'Journaliste', value: 'Journaliste' },
                  { label: 'Autre', value: 'Autre' }
                ]}
                onChange={this.setProfil}
                hasError={this.state.profil === ''}
                errorMessage={'Ce champ est requis'}
              />
            </div>

            <div className="form-contact__input">
              <TextInput
                id="name"
                isLight
                placeholder="Nom complet*"
                errorMessage="Ce champ est requis"
                hasError={this.state.name !== null && this.state.name.length === 0}
                onChange={this.setName}
              />
            </div>
          </div>
          <TextInput
            id="email"
            isLight
            placeholder="Adresse mail*"
            errorMessage={this.state.email === '' ? 'Ce champ est requis' : "Cet e-mail n'est pas valide"}
            hasError={this.state.email !== null && !validateEmail(this.state.email)}
            onChange={this.setEmail}
          />

          <div className="input form-contact__textarea input--light">
            <textarea placeholder="Votre message" id="message" name="textarea" onChange={this.setMessage} />
          </div>
          <div className="box box--smoke input--file form-contact__file">
            <i className="icon icon-pj" />
            <label htmlFor="file">
              {this.state.file ? (
                <span>{getFileNameFromPath(this.state.file)}</span>
              ) : (
                <Fragment>
                  <span>Ajouter un fichier **</span> ou glissez-le ici
                </Fragment>
              )}
            </label>
            <input id="file" name="inputFile" type="file" accept="application/pdf" onChange={this.setFile} />
          </div>
          {isPopulate && object === 'Candidature Spontanée' && (
            <div className="box box--smoke input--file form-contact__file">
              <i className="icon icon-pj" />
              <label htmlFor="file2">
                {this.state.file2 && this.state.file2 !== '' ? (
                  <span>{getFileNameFromPath(this.state.file2)}</span>
                ) : (
                  <Fragment>
                    <span>Ajouter un second fichier **</span> ou glissez-le ici
                  </Fragment>
                )}
              </label>
              <input id="file2" name="inputFile2" type="file" accept="application/pdf" onChange={this.setFile2} />
            </div>
          )}
          <div className="form-action">
            <div>
              {error ? (
                <p>
                  <span>{error}</span>
                </p>
              ) : (
                sendStatus === STATUS_SUCCESS && (
                  <p>
                    <span style={{ color: '#4CB848', fontSize: '18px' }}>Votre demande a bien été envoyée</span>
                  </p>
                )
              )}
              <p className="ft-tertiary">* champs obligatoires</p>
              <p className="ft-tertiary ft-black-secondary">** taille max : 5 Mo</p>
            </div>
            <div>
              <button className="ft-500 ft-black-secondary" type="reset">
                <Link to="/contact">Annuler</Link>
              </button>
              <button className="btn btn--primary js-contact-send" type="button" onClick={this.handleSubmit}>
                Envoyer mon message
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default ContactForm;
